import React from 'react';
import { projectOffers } from '../data/content';
import { Reveal } from './showcase/Reveal';
export function ProjectMenu() {
  return <section id="what-i-build" aria-labelledby="what-i-build-title" className="border-b border-white/5 bg-ink-800" data-id="element-180" data-mp="2wgzo1jn9kikx">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-181" data-mp="367aqt2v7olq8">
        <Reveal data-id="element-182" data-mp="369f6ei2h396c">
          <h2 id="what-i-build-title" className="max-w-2xl font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl" data-id="element-183" data-mp="2ihq8mm6vtsi0">
            What I build.
          </h2>
        </Reveal>

        <ul className="mt-8 grid gap-5 md:grid-cols-2" data-id="element-184" data-mp="2rjhdjotllvat">
          {projectOffers.map((offer, index) => <li key={offer.name} className="h-full" data-id="element-185" data-mp="2mia8vymr5c8d" data-mpi={index}>
              <Reveal delay={0.06 * index} className="h-full" data-id="element-186" data-mp="6s73djyramj7">
                <div className="flex h-full flex-col rounded-xl border border-white/10 bg-ink-700 p-7" data-id="element-187" data-mp="6qmcq5fkbnqm">
                  <h3 className="font-display text-xl font-semibold tracking-tight text-white" data-id="element-188" data-mp="1sukfab09zlw">
                    {offer.name}
                  </h3>
                  <p className="mt-2 text-sm font-semibold text-brand" data-id="element-189" data-mp="12rf0vq9n4yhx">{offer.price}</p>
                  <p className="mt-4 text-sm leading-relaxed text-white/60" data-id="element-190" data-mp="17ray96nu1roi">
                    {offer.body}
                  </p>
                </div>
              </Reveal>
            </li>)}
        </ul>

        <Reveal className="mt-8" data-id="element-191" data-mp="f35ccgl1lwn3">
          <p className="text-sm text-white/55" data-id="element-192" data-mp="f46z3ibf87kn">
            Project work is scoped after your audit. Nothing is quoted blind.
          </p>
        </Reveal>
      </div>
    </section>;
}